import LoadingDisplay from "../common/LoadingDisplay/LoadingDisplay";
import memeService from "../../services/MemeService";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./login.css";

const LoggedIn = () => {
    const navigate = useNavigate();
    const hasLoggedInRef = useRef(false);

    useEffect(() => {
        const handleError = (error) => {
            console.error("Login failed! : ", error);
            navigate("/?params=DEFAULT_ERROR");
        };

        const handleLogin = (isAuthenticated, error) => {
            if (isAuthenticated) {
                navigate("/dashboard");
            } else {
                error ? handleError(error) : navigate("/");
            }
        };

        const isAuthenticated = memeService.isAuthenticated();

        try {
            const twitchAuthCode = new URLSearchParams(
                window.location.search,
            ).get("code");

            // Avoid logging in again if the login process was already attempted
            if (!hasLoggedInRef.current) {
                if (twitchAuthCode && !isAuthenticated) {
                    hasLoggedInRef.current = true;

                    // Assiging auth code
                    memeService.logIn(twitchAuthCode.trim()).then((res) => {
                        handleLogin(res.status == 200);
                    });
                } else handleLogin(isAuthenticated);
            }
        } catch (error) {
            handleLogin(false, error);
        }
    }, [navigate]);

    return (
        <div className="loginCenterBackground">
            <h2 className="AppSTitleName">
                STREAM <span className="AppSTitleName2">MEMES</span>
            </h2>
            <div>
                <LoadingDisplay />
            </div>
        </div>
    );
};

export default LoggedIn;
